module.exports = __webpack_public_path__ + "img/workshops_1.926a404a.png";